module.exports = __webpack_public_path__ + "img/barrier2.f865eb94.svg";